import type { Point } from '../domain/types'

export class PointerInput {
  private readonly onPointerDown = (event: PointerEvent): void => {
    if (!event.isPrimary && event.pointerType === 'mouse') return
    event.preventDefault()
    const rect = this.canvas.getBoundingClientRect()
    const point: Point = {
      x: ((event.clientX - rect.left) / rect.width) * this.worldSize().width,
      y: ((event.clientY - rect.top) / rect.height) * this.worldSize().height,
    }
    this.canvas.setPointerCapture?.(event.pointerId)
    this.onFire(point)
  }

  private readonly preventContextMenu = (event: MouseEvent): void => event.preventDefault()
  private readonly onPointerCancel = (event: PointerEvent): void => {
    if (this.canvas.hasPointerCapture?.(event.pointerId)) this.canvas.releasePointerCapture(event.pointerId)
  }

  constructor(
    private readonly canvas: HTMLCanvasElement,
    private readonly worldSize: () => { width: number; height: number },
    private readonly onFire: (point: Point) => void,
  ) {
    canvas.addEventListener('pointerdown', this.onPointerDown)
    canvas.addEventListener('pointercancel', this.onPointerCancel)
    canvas.addEventListener('contextmenu', this.preventContextMenu)
  }

  destroy(): void {
    this.canvas.removeEventListener('pointerdown', this.onPointerDown)
    this.canvas.removeEventListener('pointercancel', this.onPointerCancel)
    this.canvas.removeEventListener('contextmenu', this.preventContextMenu)
  }
}
